class FakeUploadClock {
    private _progress = 0;
    private _maxProgressValue = 80;
    private _progressJump = 10;
    private _timoutId;
    private _sendDataBack;
    private _minSec = 1000;
    private _maxSec = 8000;

    setCallBack = (sendDataBack, maxProgressValue = this._maxProgressValue) => {
        this._maxProgressValue = maxProgressValue;
        this._sendDataBack = sendDataBack;
    }
    randomSecond = () => Math.floor((Math.random() * this._maxSec) + this._minSec);
    _setTimeout = () => {
        if (this._progress < this._maxProgressValue) {
            this._timoutId = setTimeout(() => {
                if (this._progress < this._maxProgressValue) {
                    this._progress += this._progressJump;
                    this._sendDataBack(this._progress);
                } else {
                    this._timoutId && clearTimeout(this._timoutId);
                    this._timoutId = null;
                }
            }, this.randomSecond());
        } else {
            this._timoutId && clearTimeout(this._timoutId);
            this._timoutId = null;
        }
    }
    runClock = () => {
        this._setTimeout();
    }
    receiveProgressFromOutSide = (progress) => {
        this._progress = progress;
        this._sendDataBack(this._progress);
    }

}

const fakeUploadClock = new FakeUploadClock();

export default fakeUploadClock;
